import React from 'react';

import { TableCell } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { IFilters } from '../../types';

interface IProps {
  filters: IFilters;
  period1Label: string;
  period2Label: string;
}

const StaffEvolutionListHeadPeriod = React.memo(
  ({ filters, period1Label, period2Label }: IProps) => {
    const { t } = useTranslation();

    return (
      <>
        <TableCell>
          <div>{period1Label}</div>
          <div>{filters.period1SchoolYear}</div>
        </TableCell>

        <TableCell>
          <div>{period2Label}</div>
          <div>{filters.period2SchoolYear}</div>
        </TableCell>

        <TableCell>{t('general.evolution')}</TableCell>
      </>
    );
  },
);

export default StaffEvolutionListHeadPeriod;
